const setFristChildrenCitizenIdExpireDate = (data = null,text = null) => {
  return {
    type: 'SET_FRISTCHILDRENCITIZENIDEXPIREDATE',
    data,
    text
  }
}

export default {
  setFristChildrenCitizenIdExpireDate,
}
